import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children"];
import React from 'react';
import ScriptTag from '../ScriptTag';
function getWrappedScriptTag(child) {
  if (!child) return child;
  if (typeof child === 'string') return child;
  const _child$props = child.props,
    {
      children
    } = _child$props,
    scriptProps = _objectWithoutProperties(_child$props, _excluded);
  if (child.type === 'script') return /*#__PURE__*/React.createElement(ScriptTag, _extends({}, scriptProps, {
    key: child.key
  }));
  if (!children) return child;
  return React.cloneElement(child, child.props, wrapScriptTags(children));
}
function wrapScriptTags(parsedCode) {
  if (Array.isArray(parsedCode)) {
    parsedCode.forEach((child, index) => {
      try {
        // modify children array as we just want to wrap single components
        // eslint-disable-next-line no-param-reassign
        parsedCode[index] = getWrappedScriptTag(child);
      } catch {
        // catch read-only element errors
      }
    });
    return parsedCode;
  }
  return getWrappedScriptTag(parsedCode);
}
export default wrapScriptTags;
//# sourceMappingURL=wrap-script-tags.js.map